import 'uni-pages';
// @ts-ignore
wx.__webpack_require_UNI_MP_PLUGIN__ = __webpack_require__;import '@dcloudio/vue-cli-plugin-uni/packages/uni-cloud/dist/index.js';import Vue from 'vue'
import App from './App'
import store from './store'
import config from '@/app.config.js'
import openApp from './common/openApp.js';

// 引入 uView UI
import uView from 'uview-ui';
Vue.use(uView);

// 引入 vk框架前端
import vk from 'uni_modules/vk-unicloud/vk_modules/vk-unicloud-page';
Vue.use(vk);

// 初始化 vk框架
Vue.prototype.vk.init({
	Vue, // Vue实例
	config, // 配置
});

// mixins
import WechatShareMixin from "common/mixins/wechat-share";
import NavigatorMixin from 'common/mixins/navigator';

Vue.mixin(WechatShareMixin);
Vue.mixin(NavigatorMixin);

Vue.config.productionTip = false
if (config.h5.openApp.show) {
	openApp();
}
App.mpType = 'app'

const app = new Vue({
	store,
	...App
});
app.$mount();